var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5306 30.9796C28.2857 32.7755 25.1429 34.1224 22 34.1224C14.8163 34.1224 9.87755 28.7347 9.87755 21.551C9.87755 14.3673 14.8163 9.42857 22 9.42857C25.1429 9.42857 28.2857 10.3265 30.5306 12.5714L31.8776 13.9184L39.0612 7.18367L37.2653 5.83673C33.2245 2.24489 27.8367 0 22 0C9.42858 0 0 9.42857 0 22C0 34.5714 9.42858 44 22 44C27.8367 44 33.2245 41.7551 37.2653 38.1633L39.0612 36.8163L31.8776 29.6327L30.5306 30.9796Z",
    fill: "#17313B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5507 29.1838C25.5182 29.1838 28.7344 25.9675 28.7344 22.0001C28.7344 18.0327 25.5182 14.8164 21.5507 14.8164C17.5833 14.8164 14.3671 18.0327 14.3671 22.0001C14.3671 25.9675 17.5833 29.1838 21.5507 29.1838Z",
    fill: "#EF4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconC);
export default __webpack_public_path__ + "static/media/icon_c.ccab7308430dbcf249ec4244d801a30d.svg";
export { ForwardRef as ReactComponent };